import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'badgeColor',
  standalone: true,
})
export class BadgeColorPipe implements PipeTransform {
  private readonly statusColorMap: { [key: string]: string } = {
    draft: 'text-draft',
    canceled: 'text-canceled',
    cancelled: 'text-canceled',
    false: 'text-no-action',
    '5': 'text-priority-5',
    '4': 'text-priority-4',
    '3': 'text-priority-3',
    '2': 'text-priority-2',
    '1': 'text-priority-1',
    '0': 'text-priority-0',
  };

  transform(stage: string, requireAction: string, priority: string): string {
    if (stage === 'draft') return this.statusColorMap['draft'];
    if (stage === 'canceled' || stage === 'cancelled') return this.statusColorMap['canceled'];
    if (stage === 'paid') return this.statusColorMap['false'];

    if (!requireAction) return this.statusColorMap['false'];

    if (requireAction) {
      return this.statusColorMap[priority] || 'text-priority-0';
    }

    return 'text-bg-primary';
  }
}
